import { render, staticRenderFns } from "./Comportamiento.vue?vue&type=template&id=22711750&scoped=true"
import script from "./Comportamiento.vue?vue&type=script&lang=js"
export * from "./Comportamiento.vue?vue&type=script&lang=js"
import style0 from "./Comportamiento.vue?vue&type=style&index=0&id=22711750&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "22711750",
  null
  
)

export default component.exports